module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel03_770_280_ko-0a8d326c9ff9562b57ac75dd6f799826.jpg";